// Title directory (page.titles): fetches the title index from the App Proxy API and renders it with row filtering.

// Must match the exact "row" value returned by the API; do not localize.
const OTHER_ROW = 'その他';

const rootEl = document.querySelector('[data-page-titles]');
if (rootEl) {
  init(rootEl);
}

function init(rootEl) {
  const config = readConfig();
  const endpoint = rootEl.dataset.endpoint;
  const togglesEl = rootEl.querySelector('[data-titles-toggles]');
  const listEl = rootEl.querySelector('[data-titles-list]');
  const templates = {
    toggle: document.querySelector('[data-template="toggle"]'),
    section: document.querySelector('[data-template="section"]'),
    link: document.querySelector('[data-template="link"]'),
  };

  if (!endpoint || !togglesEl || !listEl || !templates.toggle || !templates.section || !templates.link) {
    return;
  }

  fetch(endpoint, { headers: { Accept: 'application/json' } })
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    })
    .then((data) => render({ togglesEl, listEl, templates, config, data }))
    .catch(() => showState(listEl, config.error));
}

function render({ togglesEl, listEl, templates, config, data }) {
  const groups = Array.isArray(data) ? data : [];

  togglesEl.textContent = '';
  listEl.textContent = '';

  if (!groups.length) {
    showState(listEl, config.empty);
    return;
  }

  togglesEl.appendChild(makeToggle(togglesEl, listEl, templates.toggle, config.all, '', true));

  groups.forEach((group) => {
    const rowKey = String(group.row || '');
    togglesEl.appendChild(makeToggle(togglesEl, listEl, templates.toggle, rowLabel(rowKey), rowKey, false));

    const sections = Array.isArray(group.sections) ? group.sections : [];
    sections.forEach((sectionData) => {
      const sectionEl = makeSection(templates, sectionData);
      sectionEl.dataset.row = rowKey;
      if (isOtherRow(rowKey)) sectionEl.dataset.hideHeading = 'true';
      listEl.appendChild(sectionEl);
    });
  });
}

function applyFilter(listEl, row) {
  listEl.querySelectorAll('.page-titles__section').forEach((sec) => {
    sec.hidden = row !== '' && sec.dataset.row !== row;
  });
}

function isOtherRow(row) {
  return row === OTHER_ROW;
}

function rowLabel(row) {
  if (!row) return '';
  return isOtherRow(row) ? row : `${row}行`;
}

function makeToggle(togglesEl, listEl, template, label, row, active) {
  const node = template.content.firstElementChild.cloneNode(true);
  node.textContent = label;
  if (active) node.classList.add('is-active');
  node.setAttribute('aria-pressed', String(active));
  node.addEventListener('click', () => {
    togglesEl.querySelectorAll('.page-titles-toggle-button').forEach((btn) => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
    node.classList.add('is-active');
    node.setAttribute('aria-pressed', 'true');
    applyFilter(listEl, row);
  });
  return node;
}

function makeSection(templates, sectionData) {
  const node = templates.section.content.firstElementChild.cloneNode(true);
  node.querySelector('.page-titles-section-heading').textContent =
    sectionData && sectionData.section ? sectionData.section : '';
  const titles = sectionData && Array.isArray(sectionData.titles) ? sectionData.titles : [];
  titles.forEach((title) => node.appendChild(makeLink(templates, title)));
  return node;
}

function makeLink(templates, title) {
  const node = templates.link.content.firstElementChild.cloneNode(true);
  node.querySelector('.page-titles-link__text-name').textContent = title && title.title ? title.title : '';
  node.querySelector('.page-titles-link__text-count').textContent = formatCount(title && title.productCount);
  const href = titleUrl(title);
  if (href) node.setAttribute('href', href);
  return node;
}

function titleUrl(title) {
  if (!title || title.publicId === null || title.publicId === undefined) return '';
  return `/collections/title-${encodeURIComponent(String(title.publicId))}`;
}

function formatCount(count) {
  return count === null || count === undefined || count === '' ? '' : `(${count})`;
}

function showState(listEl, message) {
  listEl.textContent = '';
  const p = document.createElement('p');
  p.className = 'page-titles__state';
  p.textContent = message || '';
  listEl.appendChild(p);
}

function readConfig() {
  const defaults = { all: 'すべて', error: '', empty: '' };
  const el = document.querySelector('[data-page-titles-config]');
  if (!el) return defaults;
  try {
    return Object.assign(defaults, JSON.parse(el.textContent));
  } catch (error) {
    return defaults;
  }
}
